import { render } from "./Participants.vue?vue&type=template&id=4dc0df0a&scoped=true"
import script from "./Participants.vue?vue&type=script&lang=js"
export * from "./Participants.vue?vue&type=script&lang=js"

import "./Participants.vue?vue&type=style&index=0&id=4dc0df0a&lang=scss&scoped=true"

import exportComponent from "/Users/vonwong/Dropbox/ClaudeCode/MeetingOS/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc0df0a"]])

export default __exports__